import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../services/data.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MessageService } from '../services/message.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent {
  @ViewChild('fileInput')
  fileInputRef!: ElementRef;
  @ViewChild('fileInputTwo')
  fileInputRefTwo!: ElementRef;

  url: string = 'users';
  id!: string;
  form!: FormGroup;
  roles: Array<any> = [];
  files: any = [];
  //nameFile!: string;
  upload = false;
  upload_two = false;
  apiUrl = environment.apiUrl;
  //previewUrl: string | null = null; // Nueva propiedad para el preview
  imagePreviews: { [key: string]: string } = {};
  indicatives: Array<any> = [];
  countries: Array<any> = [];
  showPassword = false;
  isLoading = false;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private http: HttpClient
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      identification: [''],
      rut: [''],
      role: ['', [Validators.required]],
      status: [''],
      password: [''],
      phone: [''],
      indicative: [''],
      type: [''],
      img: [''],
      imgIdentification: [''],
      address: ['', [Validators.required]],
      apt: [''],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });
    this.indicatives = [
      '+1',
      '+57',
      '+52',
      '+55',
      '+54',
      '+56',
      '+58',
      '+34',
      '+44',
    ];

    this.cities();
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('getData response', response);
      this.form.patchValue({
        username: response.username,
        firstname: response.firstname,
        lastname: response.lastname,
        identification: response.identification,
        rut: response.rut,
        role: response.role,
        status: response.status,
        phone: response.phone,
        indicative: response.indicative,
        type: response.type,
        img: response.img,
        imgIdentification: response.imgIdentification,
        address: response.address,
        apt: response.apt,
        city: response.city,
        state: response.state,
        country: response.country,
      });
      console.log('profileImgUrl', this.form.value);
    });
  }

  /* updateData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/administracion/users');
        } else {
          this.messageService.add(response.msg, 'danger');
        }
      });
  } */

  selectFile() {
    this.fileInputRef.nativeElement.click();
  }

  selectFileTwo() {
    this.fileInputRefTwo.nativeElement.click();
  }

  captureFile(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    //this.files.push(file);
    this.upload = true;
    this.form.patchValue({
      img: nameFile,
    });
    this.updateFileList(file, 'img');
    this.previewFile(file, 'img'); // si quieres previsualización
  }

  captureFileTwo(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    ///this.files.push(file);
    this.upload_two = true;
    this.form.patchValue({
      imgIdentification: nameFile,
    });
    this.updateFileList(file, 'imgIdentification');
    this.previewFile(file, 'imgIdentification');
  }

  updateData(): void {
    this.isLoading = true;
    const dataForm = new FormData();

    Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        dataForm.append(key, value as any);
      }
    });

    console.log('files', this.files);
    /* if (this.files?.length) {
      this.files.forEach((f) => dataForm.append('files', f));
    } */
    if (this.files?.length) {
      this.files.forEach((fileObj) => {
        dataForm.append('files', fileObj.file);
      });
    }
    console.log('files2', this.files);

    let img = this.form.get('img')?.value;
    let firstname = this.form.get('firstname')?.value;
    let lastname = this.form.get('lastname')?.value;

    this.dataService.putData(`${this.url}/edit/${this.id}`, dataForm).subscribe(
      (res) => {
        if (res.rst) {
          //this.messageService.add(res.msg, 'info');
          this.form.reset();
          const userStr = localStorage.getItem('user');
          let user = userStr ? JSON.parse(userStr) : null;
          console.log('img', img);

          if (user) {
            user.img = img;
            user.firstname = firstname;
            user.lastname = lastname;
            localStorage.setItem('user', JSON.stringify(user));
          }
          this.isLoading = false;
          this.router.navigateByUrl('/dashboard');
        } else {
          this.messageService.add(res.msg, 'secondary');
        }
      },
      (err) => {
        console.error('Error al guardar', err);
        this.messageService.add(
          'Hubo un problema al guardar los datos',
          'secondary'
        );
      }
    );
  }

  updateFileList(file: File, fieldKey: string) {
    const index = this.files.findIndex((f) => f.fieldKey === fieldKey);
    if (index !== -1) {
      this.files[index] = { file, fieldKey }; // reemplazar si ya existe
    } else {
      this.files.push({ file, fieldKey }); // agregar si no existe
    }
  }

  previewFile(file: File, fieldKey: string) {
    const reader = new FileReader();
    reader.onload = () => {
      //this.previewUrl = reader.result as string; // Guardar el preview
      this.imagePreviews[fieldKey] = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  /* removeFile() {
    console.log('this.files', this.files);
    this.upload = false;
    this.previewUrl = null; // Limpiar el preview
    this.form.patchValue({
      img: '',
    });
  } */

  removeFile(fieldKey: string) {
    console.log('this.files', this.files);
    this.files = this.files.filter((f) => f.fieldKey !== fieldKey);
    delete this.imagePreviews[fieldKey];

    //console.log('this.files', this.files);
    //console.log('this.imagePreviews', this.imagePreviews);

    if (fieldKey === 'img') {
      this.upload = false;
      this.form.patchValue({
        img: '',
      });
    } else if (fieldKey === 'imgIdentification') {
      this.upload_two = false;
      this.form.patchValue({
        imgIdentification: '',
      });
    }
  }

  /* get profileImgUrl(): string {
    const img = this.form.get('img')?.value;
   
    return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
  } */

  getProfileImgUrl(fieldKey: string): string {
    // Si hay un preview de nueva imagen, mostrarlo
    if (this.imagePreviews[fieldKey]) {
      return this.imagePreviews[fieldKey];
    }

    console.log('fieldKey', fieldKey);
    console.log('imagePreviews', this.imagePreviews);

    const img = this.form.get(fieldKey)?.value;
    return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
  }

  cities() {
    this.http
      .get('https://restcountries.com/v3.1/all?fields=name')
      .subscribe((data: any[]) => {
        this.countries = data;
        this.countries = data.map((el) => el.name.common);
        this.countries.sort((a, b) => a.localeCompare(b));

        console.log('countries', this.countries);

        // Establecer "United States" como valor predeterminado si existe
        const EEUU = this.countries.find(
          (name) => name.toLowerCase() === 'united states'
        );

        //console.log('EEUU',EEUU)
        /* if (EEUU) {
          this.data.country = EEUU;
        } */
      });
  }

  /* formatPhone() {
    const phoneNumber = (this.form.get('phone')?.value || '').replace(
      /[^\d]/g,
      ''
    );

    const phoneNumberLength = (this.form.get('phone')?.value || '').length;
    console.log('logitud');
    console.log(phoneNumberLength);
    if (phoneNumberLength <= 3) {
      //this.data.phone = phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 4) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4),
      });
    } else if (phoneNumberLength == 5) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 6) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      //console.log(this.data.phone);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 7) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 8) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 9) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 10) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3) +   ') ' + phoneNumber.slice(3, 6) + ' - ' + phoneNumber.slice(6, 10);
      this.form.patchValue({
        phone:
          '(' +
          phoneNumber.slice(0, 3) +
          ') ' +
          phoneNumber.slice(3, 6) +
          ' - ' +
          phoneNumber.slice(6, 10),
      });
    }
  } */

  formatPhone(event: Event) {
    const input = event.target as HTMLInputElement;

    let digits = input.value.replace(/\D/g, '');
    digits = digits.slice(0, 10);

    let formatted = '';
    if (digits.length <= 3) {
      formatted = digits;
    } else if (digits.length <= 6) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(
        3,
        6
      )} - ${digits.slice(6)}`;
    }

    this.form.get('phone')?.setValue(formatted, { emitEvent: false });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
